import { CALL_API, METHODS } from 'app/react/state/middleware/api'
import * as Endpoints from './endpoints'
import * as Schemas from './schemas'
import * as AttendeeSchemas from '../../attendees/schemas'
import { setCurrentContextId } from 'app/react/state/actions/_index'

export const ONE_REQUEST = 'ONE_CREW_REQUEST';
export const ONE_SUCCESS = 'ONE_CREW_SUCCESS';
export const ONE_FAILURE = 'ONE_CREW_FAILURE';
export const ONE_TYPES = [
    ONE_REQUEST,
    ONE_SUCCESS,
    ONE_FAILURE
];

export const setCurrentId = id =>
    setCurrentContextId(Schemas.ENTITY_CONTEXT_ID_KEY, id);

export const createOne = (
    accountId,
    eventId,
    bookingId,
    values
) => ({
    [CALL_API]: {
        types: ONE_TYPES,
        method: METHODS.POST,
        body: values,
        endpoint: Endpoints.createOne(eventId, bookingId),
        schema: Schemas.entity,
    },
    accountId,
    eventId,
    bookingId
});

export const fetchOne = (
    accountId,
    eventId,
    bookingId,
    crewId,
    includes
) => ({
    [CALL_API]: {
        types: ONE_TYPES,
        method: METHODS.GET,
        endpoint: Endpoints.fetchOne(eventId, bookingId, crewId, includes),
        schema: Schemas.entity,
        id: crewId
    },
    accountId,
    eventId,
    bookingId
});

export const updateOne = (
    accountId,
    eventId,
    bookingId,
    crewId,
    values
) => ({
    [CALL_API]: {
        types: ONE_TYPES,
        method: METHODS.PUT,
        body: values,
        endpoint: Endpoints.updateOne(eventId, bookingId, crewId),
        schema: AttendeeSchemas.entity,
        id: crewId,
    },
    accountId,
    eventId,
    crewId
});

export const deleteOne = (
    accountId,
    eventId,
    bookingId,
    crewId
) => ({
    [CALL_API]: {
        types: ONE_TYPES,
        method: METHODS.DELETE,
        endpoint: Endpoints.deleteOne(eventId, bookingId, crewId),
        schema: AttendeeSchemas.entity,
        id: crewId
    },
    accountId,
    eventId,
    bookingId,
    crewId
});
